// src/Pages/SalaryDetail.jsx
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { useParams, Link, useNavigate } from "react-router-dom";
import { BiRupee } from "react-icons/bi";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import "./CustomerList.css";
import axios from "axios";

const parsePossibleDate = (value) => {
  if (!value) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value);
  const parts = value.split("/");
  if (parts.length === 3) {
    const d = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10) - 1;
    const y = parseInt(parts[2], 10);
    const dt = new Date(y, m, d);
    return isNaN(dt) ? null : dt;
  }
  const dt = new Date(value);
  return isNaN(dt) ? null : dt;
};

// const calculateSalary = (item) => {
//   const workingDays = (item.totalDays || 30) - (item.lop || 0);
//   const gross = item.actualSalary || 0;
//   const hra = (gross * (item.hraPercent || 0)) / 100;
//   const epf = (gross * (item.epfPercent || 0)) / 100;
//   const savings = (gross * (item.savingsPercent || 0)) / 100;
//   const iste = (gross * (item.istePercent || 0)) / 100;
//   // const totalDeduction = epf + savings + (item.others || 0);
//   const netSalary = gross - totalDeduction;
//   return { workingDays, gross, hra, epf, savings, iste, totalDeduction, netSalary };
// };

// const readSalaryRecords = () => {
//   try {
//     const raw = localStorage.getItem("salary_records_v1");
//     if (raw) return JSON.parse(raw);
//   } catch (e) {}
//   // fallback demo
//   return [
//     {
//       user_id: 1,
//       name: "PRABHA",
//       designation: "AO",
//       doj: "17/2/2021",
//       actualSalary: 30000,
//       totalDays: 30,
//       lop: 2,
//       hraPercent: 20,
//       epfPercent: 12,
//       savingsPercent: 7,
//       istePercent: 0,
//       others: 0,
//     },
//     {
//       user_id: 2,
//       name: "KUMAR",
//       designation: "Lecturer",
//       doj: "2020-06-10",
//       actualSalary: 28000,
//       totalDays: 30,
//       lop: 1,
//       hraPercent: 20,
//       epfPercent: 12,
//       savingsPercent: 7,
//       istePercent: 0,
//       others: 0,
//     },
//   ];
// };

const SalaryDetail = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { user_id } = useParams();
  const navigate = useNavigate();
  const userId = Number(user_id);

  const [records, setRecords] = useState([]);
  const [record, setRecord] = useState(null);
  const [salaryList, setSalaryList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    axios.post(`${API_BASE_URL}salary_user_sf_list.php`, { user_id: userId })
      .then((response) => {
        if (response.data.head.code === 200) {

          const list = response.data.body;

          setSalaryList(list);
          setRecords(list);

          console.log("test", list);  // now NOT empty

          const found = list.find(r => Number(r.user_id) === userId) || null;
          setRecord(found);
          setIsLoading(false);
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setSalaryList([]);
          setRecords([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setSalaryList([]);
        setRecords([]);
        setIsLoading(false);
      });
  }, [userId]);


  const handleDelete = (deleteId) => {
    if (!window.confirm("Delete this salary record?")) return;
    const updated = records.filter((r) => Number(r.user_id) !== Number(deleteId));
    setRecords(updated);
    localStorage.setItem("salary_records_v1", JSON.stringify(updated));
    navigate("/salary");
  };

  // if (!record) {
  //   return (
  //     <Container fluid className="my-4 outer-container">
  //       <h3 className="text-center">Salary Details</h3>
  //       <div className="text-center my-4">
  //         <p>No salary record found for id {userId}.</p>
  //         <Button variant="secondary" onClick={() => navigate("/salary")}>
  //           Back to Salary List
  //         </Button>
  //       </div>
  //     </Container>
  //   );
  // }

  // const calc = calculateSalary(record);

  return (
    <Container fluid className="my-4 outer-container">
      <Row className="mb-3">
        <Col>
          <h3 className="text-center">Salary Details</h3>
          {salaryList.length === 0 && isLoading == true && (
            <Container fluid className="outer-container my-4">
              <Row>
                <Col>
                  <div className="not-found-box">Loading...</div>
                </Col>
              </Row>
            </Container>
          )}
        </Col>
      </Row>
      <Row className="mb-3 justify-content-end">
        <Col md="auto">
          <Link
            // to="/addsalary" 
            to={`/addsalary/${user_id}`}
            className="btn-top">
            Add Salary
          </Link>
          <Link to="/userlist" className="btn-top m-2">
            Back
          </Link>
          {/* <Button className="m-2 p-2 btn-top" onClick={() => window.history.back()}>Back</Button> */}
        </Col>
      </Row>

      {/* Table-style detail using same classes as CustomerList */}
      <div className="customer-table-wrapper">
        <Table bordered responsive className="customer-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Designation / Dept.</th>
              <th>DOJ</th>
              <th>Actual Salary</th>
              <th>Total Days</th>
              <th>LoP</th>
              <th>Working Days</th>
              <th>Total Deduction</th>
              <th>Net Salary</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {salaryList.length > 0 ? (
              salaryList.map((record, index) => (
                <tr key={record.salary_id}>
                  {/* <td>{index + 1}</td> */}
                  <td>{salaryList.length - index}</td>
                  <td>{record.name}</td>

                  <td>
                    {record.desig_name} - {record.depart_name}
                  </td>

                  <td>{record.date_of_join}</td>

                  <td>
                    <BiRupee />
                    {record.actual}
                  </td>

                  <td>{record.total_days}</td>

                  <td>{record.lop}</td>

                  <td>{record.working_days}</td>

                  <td>
                    <BiRupee />
                    {record.deduction}
                  </td>

                  <td>
                    <BiRupee />
                    {record.net_salary}
                  </td>

                  <td className="action-icons">
                    <Link to={`/viewsalary/${record.salary_id}`} className="me-2">
                      <FaEye className="view-icon" />
                    </Link>

                    <Link to={`/editsalary/${record.salary_id}`} className="me-2">
                      <FaEdit className="edit-icon" />
                    </Link>

                    <FaTrash
                      className="delete-icon"
                      onClick={() => handleDelete(record.salary_id)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="text-center text-muted">
                  No salary records found
                </td>
              </tr>
            )}
          </tbody>

        </Table>
      </div>
    </Container>
  );
};

export default SalaryDetail;
